import './new-campaign.scss';

import { FormProvider } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";
import { Button } from "primereact/button";

import HeaderContent from "@shared/ui/header-content/header-content";
import FormCampaign from "../form-campaign/form-campaign";
import { useNewCampaign } from './new-campaign.hook';

export function NewCampaign() {  
  const {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  } = useNewCampaign();

  return (
    <div id="NewCampaign" className="campaign">
      <HeaderContent
        title={<h1>New Campaign</h1>}
        backIcon={<FaChevronLeft />}
        onBack={() => navigate("../")}
      >
        <Button
          className="w-full block"
          label="Save"
          disabled={isCreating}
          onClick={handleSubmit(handleValidate, handleValidateError)}
        ></Button>
      </HeaderContent>

      <div className="p-7">
        <FormProvider {...formMethod}>
          <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4">
            <FormCampaign />
          </section>
        </FormProvider>
      </div>
    </div>
  );
}

export default NewCampaign;